import React, {createContext, useContext, useState} from "react";
import {getBaskets} from "./crud/basketCrud";
import {AutoIncrementer} from "../../../_metronic/_helpers/AutoIncrementer";

const BasketsUIContext = createContext();

export function useBasketsUIContext() {
    return useContext(BasketsUIContext);
}

export function BasketsUIProvider({children}) {

    const [id, setId] = useState(0);
    const [baskets, setBaskets] = useState([]);
    const [basket, setBasket] = useState({
        id: 0,
        brand: "",
        model: "",
        guarantee_code: "",
        guarantee_date: null,
        guarantee_type: "",
        guarantee_condition: "",
        store: "",
        province: "",
        city: "",
        buy_date: null,
        description: ""
    });
    const [problems, setProblems] = useState([]);
    const [repairs, setRepairs] = useState([]);
    const [photos, setPhotos] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const fetchData = () => {
        getBaskets()
            .then((response) => {
                setBaskets(AutoIncrementer(response.data.data.data));
            });
    };

    const handleEdit = id => {
        setOpenEdit(true);
        setId(id);
    };

    const handleDelete = id => {
        setOpenDelete(true);
        setId(id);
    };

    const value = {
        baskets,
        setBaskets,
        problems,
        setProblems,
        photos,
        setPhotos,
        repairs,
        setRepairs,
        basket,
        setBasket,
        openError,
        setOpenError,
        error,
        setError,
        openEdit,
        setOpenEdit,
        openDelete,
        setOpenDelete,
        id,
        setId,
        handleDelete,
        handleEdit,
        fetchData,
    };

    return <BasketsUIContext.Provider value={value}>{children}</BasketsUIContext.Provider>;
}